/**
 * @desc 商户及供应商信息公用接口
 * @created: 2020/09/03
 * @author: Colorfule
 * @version : v1.0
 */

import request from '@/plugins/http';

// 获取商户/供应商的设备信息
export const getAppUserInfo = params => {
  let api = ''

  switch (params.type) {
    case 'supplier':
      api = '/supplier/getAppUserInfo'
      break;
    case 'merchant':
    default:
      api = '/merchant/card/getAppUserInfo'
      break;
  }

  delete params.type
  return request.get(api, params)
}

// 获取阿里云OSS上传签名(上传图片用)
export const getAliOSSPolicy = params => {
  return request.get('/merchant/entry/aliyunOSSPolicy', params)
}

// 获取商户详细信息
export const getMerchantDetails = params => {
  return request.get('/merchant/card/getMerchantDetail', params)
}

// 获取供应商详细信息
export const getSupplierDetails = params => {
  return request.get('/merchant/card/getMerchantDetail', params)
}

// 渠道列表
export const getChannelList = params => {
  return request.get('/routemapping/selectAll', params)
}

// 收单机构
export const getCompanyList = params => {
  return request.get('/servicer/serviceCondition', params)
}

// 可选通道
export const getPaychannels = params => {
  return request.get('/channel/listPaymentChannel', params)
}

// 扩展人员
export const getListExpand = params => {
  return request.get('/merchant/entry/listExpand', params)
}

// 城市服务商
export const getServiceList = params => {
  return request.get('/servicer/getAllServicer', params)
}



// 城市列表
export const getAllCityList = params => {
  return request.get('/merchant/entry/selectAllCity', params)
}

// 获取详情经营者信息的校验结果 merId
export const getVerification = params => {
  return request.get('/merSysReview/verification', params)
}

// 获取所有期号列表 (调用来源: T6)
export const getPeriodsList = params => {
  return request.get('/factor/periodno/list', params)
}

// 根据手机号拿到拓展人员信息
export const getExpandUser = params => {
  return request.get('/user/getExpandUser', params)
}

// 城市下拉
export const getSelectActiveCity = params => {
  return request.get('/merchant/entry/selectActiveCity', params)
}